import { isEqual } from 'lodash';
import { restoreQueryParamsIfNeeded } from '../LeadToLive/utils/navigationUtils';

export const PUSH_ROUTE = 'ROUTES/PUSH_ROUTE';
export const POP_ROUTE = 'ROUTES/POP_ROUTE';
export const REPLACE_ROUTE = 'ROUTES/REPLACE_ROUTE';

export function changeRoute(location, action) {
    switch (action) {
        case 'PUSH': {
            return {
                route: location.pathname,
                type: PUSH_ROUTE
            };
        }

        case 'REPLACE': {
            return {
                route: location.pathname,
                type: REPLACE_ROUTE
            };
        }

        case 'POP': {
            return {
                type: POP_ROUTE
            };
        }

        default: {
            return {
                route: location.pathname,
                type: PUSH_ROUTE
            };
        }
    }
}

export function goBack(history, goBackTarget = {}) {
    const { url } = goBackTarget;

    if (isEqual(url, 'goBack')) {
        history.goBack();
    } else {
        const finalUrl = restoreQueryParamsIfNeeded(history, url);
        history.replace(finalUrl);
    }
}
